export const directBookingsSettingsView = {
  loading: "Caricamento impostazioni…",

  sidebar: {
    brandTitle: "Annunci",
    brandSub: "Pannello impostazioni",
    searchPlaceholder: "Cerca…",
    generalLabel: "Generale",
    servicesName: "Servizi ed esperienze",
    servicesSub: "Un elenco per tutto l'account",
    promotionsName: "Promozioni",
    promotionsSub: "Crea · Modifica · Gestisci",
    globalChip: "GLOBALE",
    inactivePrefix: "Inattivo · {type}",
    unitsCount: "{count} unità | {count} unità",
    empty: "Nessuna struttura.",
    listingFallbackName: "Annuncio",
  },

  status: {
    active: "Attivo",
    inactive: "Inattivo",
  },

  card: {
    unsavedChanges: "Modifiche non salvate",
  },

  share: {
    title: "Link di prenotazione diretta",
    hintPrefix: "Condividi il link di",
    hintSuffix: "per ricevere prenotazioni senza commissioni.",
    copyTitle: "Copia link",
    viewAsVisitor: "Visualizza come visitatore",
    copied: "Link copiato.",
    copyError: "Impossibile copiare il link.",
    whatsappText: "Ciao 👋 Ecco il link per prenotare: {link}",
  },

  savebar: {
    unsaved: "Modifiche non salvate",
    noChanges: "Nessuna modifica in sospeso",
    saving: "Salvataggio…",
  },

  drawer: {
    close: "Chiudi",
  },

  content: {
    selectListing: "Seleziona un annuncio",
  },

  units: {
    pickerHint: "Attiva o disattiva la visibilità di ogni unità per le prenotazioni dirette, oppure aprila per configurarla (tariffe, immagini, descrizione, servizi e addebiti).",
    visible: "Visibile",
    hidden: "Nascosta",
    showTooltip: "Mostra questa unità nelle prenotazioni dirette",
    configure: "Configura",
  },

  header: {
    listingSub: "Annuncio · {count} unità · prenotazioni dirette | Annuncio · {count} unità · prenotazioni dirette",
    unitSub: "Unità · configurazione individuale",
    unitSubCoded: "Unità {code} · configurazione individuale",
    hotelSub: "Hotel / Campeggio · prenotazioni dirette",
    apartmentSub: "Appartamento / Villa · prenotazioni dirette",
  },

  tabs: {
    reservations:       { label: "Visibilità dell'annuncio", sub: "Attivala e imposta pagamento e approvazione per le prenotazioni dirette" },
    units_list:         { label: "Unità", sub: "Quali unità si possono prenotare" },
    common_images:      { label: "Aree comuni", sub: "Foto degli spazi condivisi (copertina)" },
    rate_plans:         { label: "Tariffe", sub: "Piani tariffari visibili" },
    images:             { label: "Immagini", sub: "Galleria dell'annuncio" },
    description:        { label: "Descrizione", sub: "Testo e dettagli dell'annuncio" },
    services:           { label: "Servizi", sub: "Servizi e dotazioni" },
    promotions:         { label: "Promozioni", sub: "Come vengono mostrate in questo annuncio" },
    addons:             { label: "Occupazione", sub: "Sconti e ospite aggiuntivo" },
    age_rules:          { label: "Regole per gli ospiti", sub: "Neonati, bambini e capacità" },
    additional_charges: { label: "Addebiti e tasse", sub: "IVA, pulizie e addebiti" },
    web_embed:          { label: "Integrazione web", sub: "Aggiungi il box di ricerca al tuo sito" },
  },

  save: {
    ratePlans: "Salva tariffe",
    promotions: "Salva promozioni",
    addons: "Salva addebiti",
    ageRules: "Salva regole",
    additionalCharges: "Salva addebiti e tasse",
    payments: "Salva pagamenti",
    default: "Salva",
  },

  types: {
    apartment: "Appartamento",
    house: "Casa",
    villa: "Villa",
    loft: "Loft",
    room: "Camera",
    studio: "Monolocale",
    cabin: "Baita",
    hotel: "Hotel",
    hostel: "Ostello",
    camping: "Campeggio",
  },

  toasts: {
    unitVisible: "Unità visibile nelle prenotazioni dirette.",
    unitHidden: "Unità nascosta.",
    unitUpdateError: "Impossibile aggiornare l'unità.",
  },

  errors: {
    noUserUuid: "UUID utente non trovato.",
    loadPage: "Impossibile caricare la pagina.",
    loadContext: "Impossibile caricare il contesto.",
    saveExec: "Impossibile eseguire il salvataggio.",
    saveGeneric: "Impossibile salvare.",
  },

  misc: {
    propertyFallback: "Struttura {id}",
  },
};
